// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "last-modified-date-module--bx--text-truncate--end--16-S5";
export var bxTextTruncateFront = "last-modified-date-module--bx--text-truncate--front--2nGuz";
export var row = "last-modified-date-module--row--pOpRN";
export var text = "last-modified-date-module--text--45Vrg";